import React, { Suspense } from "react";
import GoogleStatsImg from '../images/google-stats.webp';
import TrafficStatsImg from "../images/traffic-stats.webp";
import DeviceStatsImg from "../images/device-stats.webp";
const Advertise = ({ lang = 'en' }) => {
  const isArabic = lang === 'ar';
  const HelmetAr = React.lazy(() => import("./Ar/Helmet"));
  const HelmetEn = React.lazy(() => import("./En/Helmet"));
  const SharedHelmet = isArabic ? HelmetAr : HelmetEn;
  const content = {
    en: {
      title: "Advertise on Do-Calculate - The Largest Arabic Calculators Platform",
      description: "Promote your brand on Do-Calculate, the largest Arabic platform offering over 2000 free calculators and attracting thousands of daily visitors. We offer effective advertising solutions tailored to your target audience.",
      keywords: "Advertise on Do-Calculate, calculator site ads, digital marketing, Arabic ads, ad space purchase, finance ads, health ads",
      og_url: "https://do-calculate.com/en/advertise/",
      heading: 'Advertise on "Do-Calculate"',
      statsTitle: "Website Performance & Stats",
      stats: [
        { text: "150,000 Google Search Clicks in 28 Days", img: GoogleStatsImg },
        { text: "Over 500,000 Monthly Visits (+25.02% Growth)", img: TrafficStatsImg },
        { text: "85.84% of Traffic from Mobile Devices", img: DeviceStatsImg }
      ],
      whyTitle: "Why Advertise With Us?",
      whyPoints: [
        "150,000+ Monthly Google Search Clicks",
        "Over 1 Million Visits Monthly with 21.22% Growth",
        "85.84% Mobile Users (Responsive Ads)",
        "Largest Arabic Free Calculators Platform with 2,000+ Tools",
        "Diverse Audience Searching for Finance, Health, Fitness, and Math Solutions",
        "High Engagement – Visitors Spend Time Using Tools",
        "Target Specific User Segments Based on Calculator Type"
      ],
      contactTitle: "Contact Us",
      contactText: "For inquiries about ad spaces or requesting a custom quote:",
      targetTitle: "Who Can Benefit from Advertising With Us?",
      sectors: [
        {
          title: "1. Financial Services Companies",
          items: [
            "Banks & Lenders (next to loan/mortgage calculators)",
            "Insurance Companies (next to health & auto insurance calculators)",
            "Investment Firms (next to ROI calculators)"
          ]
        },
        {
          title: "2. Healthcare Sector",
          items: [
            "Hospitals & Clinics (next to BMI & pregnancy calculators)",
            "Supplement Stores (next to calorie calculators)",
            "Fitness Centers (next to bodybuilding workout calculators)"
          ]
        },
        {
          title: "3. Retail & E-commerce",
          items: [
            "Electronics Stores (next to electricity consumption calculators)",
            "Furniture Stores (next to home space calculators)",
            "Clothing Stores (next to size calculators)"
          ]
        },
        {
          title: "4. Education & Training Sector",
          items: [
            "Education Centers (next to GPA calculators)",
            "E-learning Platforms (next to curriculum conversion calculators)",
            "Language Institutes (next to language proficiency calculators)"
          ]
        }
      ]
    },
    ar: {
      title: "الإعلان على موقع احسب - أكبر منصة حاسبات باللغة العربية",
      description: "روّج لعلامتك التجارية على موقع احسب، المنصة العربية الأكبر التي تقدم أكثر من 2000 آلة حاسبة مجانية وتجذب آلاف الزوار يوميًا. نحن نقدم حلول إعلانية فعالة موجهة لجمهورك المستهدف.",
      keywords: "الإعلان على موقع احسب, إعلانات الحاسبات, التسويق الرقمي, إعلانات عربية, شراء مساحات إعلانية, إعلانات مالية, إعلانات صحية",
      og_url: "https://do-calculate.com/ar/advertise/",
      heading: 'الإعلان على "موقع احسب"',
      statsTitle: "إحصائيات وأداء الموقع",
      stats: [
        { text: "150 ألف نقرة من بحث Google خلال 28 يومًا", img: GoogleStatsImg },
        { text: "أكثر من 500 ألف زيارة شهريًا (+25.02% نمو)", img: TrafficStatsImg },
        { text: "85.84% من الزيارات من أجهزة الجوال", img: DeviceStatsImg }
      ],
      whyTitle: "لماذا تعلن معنا؟",
      whyPoints: [
        "أكثر من 150 ألف نقرة شهرية من Google",
        "أكثر من مليون زيارة شهريًا مع نمو 21.22%",
        "85.84% من المستخدمين عبر الجوال (إعلانات مستجيبة)",
        "أكبر منصة عربية للحاسبات المجانية مع أكثر من 2000 أداة",
        "جمهور متنوع يبحث عن حلول مالية وصحية ورياضية وتعليمية",
        "تفاعل عالي – الزوار يستخدمون الأدوات لوقت طويل",
        "استهداف شرائح محددة حسب نوع الآلة الحاسبة"
      ],
      contactTitle: "تواصل معنا",
      contactText: "للاستفسار حول المساحات الإعلانية أو طلب عرض سعر مخصص:",
      targetTitle: "من المستفيد من الإعلان معنا؟",
      sectors: [
        {
          title: "1. شركات الخدمات المالية",
          items: [
            "البنوك والمقرضين (بجانب حاسبات القروض والرهن العقاري)",
            "شركات التأمين (بجانب حاسبات التأمين الصحي والسيارات)",
            "شركات الاستثمار (بجانب حاسبات العائد على الاستثمار)"
          ]
        },
        {
          title: "2. قطاع الرعاية الصحية",
          items: [
            "المستشفيات والعيادات (بجانب حاسبات الحمل ومؤشر كتلة الجسم)",
            "متاجر المكملات الغذائية (بجانب حاسبات السعرات)",
            "مراكز اللياقة (بجانب حاسبات بناء الأجسام)"
          ]
        },
        {
          title: "3. التجارة الإلكترونية",
          items: [
            "متاجر الإلكترونيات (بجانب حاسبات استهلاك الكهرباء)",
            "متاجر الأثاث (بجانب حاسبات المساحات)",
            "متاجر الملابس (بجانب حاسبات المقاسات)"
          ]
        },
        {
          title: "4. التعليم والتدريب",
          items: [
            "المراكز التعليمية (بجانب حاسبات المعدل التراكمي)",
            "منصات التعلم الإلكتروني (بجانب حاسبات تحويل المناهج)",
            "معاهد اللغات (بجانب حاسبات تقييم اللغة)"
          ]
        }
      ]
    }
  };
  const c = content[lang];
  return (
    <div dir={isArabic ? "rtl" : "ltr"}>
      <Suspense fallback={<div>Loading...</div>}>
        <SharedHelmet
          TITLE={c.title}
          DESCRIPTION={c.description}
          KEYWORDS={c.keywords}
          OG_URL={c.og_url}
        />
      </Suspense>
      <div className="p-3 mb-2 bg-success text-white">
        <h1 style={{ fontSize: '24px', marginBottom: '15px' }}>
          <b>{c.heading}</b>
        </h1>
      </div>
      <div>
        <h3>{c.description}</h3>
      </div>
      <hr />
      <div className="container mt-4">
        <div className="row">
          <div className="col">
            <h2 className="mb-3" style={{ color: '#28a745' }}>{c.statsTitle}</h2>
            <div className="row mb-4">
              {c.stats.map((stat, i) => (
                <div className="col-md-4 mb-3" key={i}>
                  <div className="card h-100">
                    <div className="card-body text-center">
                      <img
                        src={stat.img}
                        alt={stat.text}
                        className="img-fluid rounded"
                        loading="lazy"
                        style={{
                          border: '1px solid #ddd',
                          width: '100%',
                          height: '300px',
                          objectFit: 'contain'
                        }}
                      />
                      <b><p className="mt-2">{stat.text}</p></b>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-6 mb-3">
            <h2 className="mb-3" style={{ color: '#28a745' }}>{c.whyTitle}</h2>
            <ul className="list-group mb-4" style={{ lineHeight: '2' }}>
              {c.whyPoints.map((point, i) => (
                <li key={i} className="list-group-item">{point}</li>
              ))}
            </ul>
          </div>
          <div className="col-md-6 mb-3">
            <div className="card sticky-top">
              <div className="card-header bg-success text-white">
                <h5 className="mb-2">{c.contactTitle}</h5>
              </div>
              <div className="card-body">
                <p>{c.contactText}</p>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <i className="fas fa-envelope mr-2"></i>
                    <a href="mailto:info@do-calculate.com">info@do-calculate.com</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <h2 className="mb-3 mt-5" style={{ color: '#28a745' }}>{c.targetTitle}</h2>
        <div className="row">
          {c.sectors.map((sector, i) => (
            <div className="col-md-6 mb-3" key={i}>
              <div className="card mb-4">
                <div className="card-body">
                  <h5 className="card-title" style={{ color: '#28a745' }}>{sector.title}</h5>
                  <p className="card-text">
                    {sector.items.map((item, j) => (
                      <span key={j}>
                        - {item}<br />
                      </span>
                    ))}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Advertise;
